//export const API_BASE_URL = 'http://localhost/ncpc-backend/ncpc_api.php';
//export const API_BASE_URL = 'http://192.168.43.1:5132/ncpc_api.php';
//export const API_BASE_URL = 'http://localhost/ncpc-backend/ncpc_api.php';
//export const API_BASE_URL = 'http://localhost:5132/ncpc_api.php';
//While live:
//export const API_BASE_URL = 'https://nelsonel.serv00.net/ncpc_api/ncpc_api.php';
//While on code server using uniben wifi:
//const API_BASE_URL = 'http://10.10.173.189:8080/proxy/5132/ncpc_api.php';
//While on code server using my hotspot:
//export const API_BASE_URL = 'http://192.168.43.1:8080/proxy/5132/ncpc_api.php';
//let API_BASE_URL1 = 'http://localhost:5132/ncpc_api.php';
//if (window.location.protocol === "https:") {
//    API_BASE_URL1 = 'https://nelsonel.serv00.net/ncpc_api/ncpc_api.php'
//}
//export const API_BASE_URL = API_BASE_URL1;
//export const API_TOKEN = "whenweallfallasleepwhereowego";
if(!process.env.REACT_APP_API_BASE_URL || !process.env.REACT_APP_API_TOKEN){
    throw Error("Missing environment variables");
}

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_TOKEN = process.env.REACT_APP_API_TOKEN;